import React, { type FC, Fragment } from 'react';
import cn from 'classnames';
import type { IProps as ITextV2Props } from '@alfa-bank/site-text-v2/src/models';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import type { TBreadcrumbsComponent } from './models';

export const Breadcrumbs: FC<TBreadcrumbsComponent> = ({
    Icon,
    Link,
    Text,
    className,
    collapseCount = 2,
    collapsed = false,
    getPaths,
    paths,
    styles,
    theme = 'white',
}) => {
    const newPaths = getPaths({
        paths,
        collapsed,
        collapseCount,
    });

    const chevronClass = cn(styles.external, styles.separator, styles.inline, {
        [styles.blueTheme]: theme === 'blue',
        [styles.whiteTheme]: theme === 'white',
    });

    const textProps: ITextV2Props = {
        kind: theme === 'white' ? 'primary' : 'primaryInverted',
        view: 'primary-small',
    };

    const stylerProp: IStyler = {
        marginTop: 0,
        marginBottom: 0,
    };

    return (
        <div className={cn(styles.container, className)}>
            {newPaths.map(({ id, link, title }, index) => (
                <Fragment key={id}>
                    <Text
                        className={cn(styles.external, styles.inline)}
                        {...textProps}
                        {...stylerProp}
                    >
                        {link ? (
                            <Link href={link} noUnderline theme={theme}>
                                {title}
                            </Link>
                        ) : (
                            <>{title}</>
                        )}
                    </Text>

                    {index < newPaths.length - 1 && <Icon className={chevronClass} />}
                </Fragment>
            ))}
        </div>
    );
};
